<template>
    <div class="vm-goal-edit" :class="{'is-hide': is_hide }">
        <i class="afd afd-x black-3" @click="remove"></i>
        <i class="afd afd-eye black-3" v-if="!is_hide" @click="toggle('hide')"></i>
        <div
            class="flex-box afd-eye-off-box flex-align-items-center lh1 purple pointer"
            @click="toggle('show')"
            v-if="is_hide"
        >
            {{$t('c.GoalEdit.text1')}}
            <i class="afd afd-eye-off ml8"></i>
        </div>
        <div class="flex-box flex-align-items-center">
            <template v-if="type == goal_type.sponsor">
                <div class="black-3 flex-box flex-align-items-center fs32">
                    <input
                        type="text"
                        inputmode="decimal"
                        v-model="monthly_fans"
                        class="purple fs32 gl-input monthly-input"
                        placeholder=""
                    >
                </div>
                <span class="black-3 ml8">{{$t('c.GoalEdit.text2')}}</span>
            </template>
            <template v-if="type == goal_type.money">
                <div class="black-3 flex-box flex-align-items-center fs32">
                    <span :class="{purple : monthly_income != ''}">￥</span>
                    <input
                        type="text"
                        inputmode="decimal"
                        v-model="monthly_income"
                        class="purple gl-input fs32 monthly-input"
                        placeholder="00.00"
                    >
                </div>
                <span class="black-3 ml8">{{$t('c.GoalEdit.text3')}}</span>
                <span class="black-3 ml16 fs12">{{$t('c.GoalEdit.text4')}}</span>
            </template>
            <template v-if="type == goal_type.sum_income">
                <div class="black-3 flex-box flex-align-items-center fs32">
                    <span :class="{purple : monthly_income != ''}">￥</span>
                    <input
                        type="text"
                        inputmode="decimal"
                        v-model="monthly_income"
                        class="purple gl-input fs32 monthly-input"
                        placeholder="00.00"
                    >
                </div>
            </template>
        </div>
        <textarea-autosize
            class="gl-textarea fs16 mt16"
            v-model="desc"
            :placeholder="$t('c.GoalEdit.text5')"
            :min-height="100"
            :max-height="200"
        ></textarea-autosize>
        <!-- <div v-if="type == goal_type.sum_income">
            <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center fs12">
                <span class="black-5">开始日期</span>
                <date-picker type="datetime" format="YYYY-MM-DD HH:mm" placeholder="设置开始日期" :editable="false" v-model="begin_time"></date-picker>
            </div>
             <div class="mt16 flex-box flex-justify-content-space-between flex-align-items-center fs12">
                <span class="black-5 flex-item-1">结束日期</span>
                <date-picker type="datetime" format="YYYY-MM-DD HH:mm" placeholder="设置结束日期" :editable="false" v-model="end_time"></date-picker>
            </div>
        </div> -->
        <div class="flex-box flex-justify-content-space-between mt16" v-if="session_user">
            <div v-if="type == goal_type.sponsor">
                <div class="purple fs12">{{percent_sponsor}}%</div>
                <div class="black-5 fs12">{{$t('c.GoalEdit.text6')}} {{session_user.creator.monthly_fans}}{{$t('c.GoalEdit.text7')}}</div>
            </div>
            <div v-if="type == goal_type.money">
                <div class="purple fs12">{{percent_money}}%</div>
                <div class="black-5 fs12">{{$t('c.GoalEdit.text8')}}￥{{session_user.creator.monthly_income}}{{$t('c.GoalEdit.text9')}}</div>
            </div>
             <div v-if="type == goal_type.sum_income">
                <template v-if="goal.goal_id">
                    <div class="purple fs12">{{(goal.percent * 100).toFixed(2) || 0}}%</div>
                    <div class="black-5 fs12">{{$t('c.GoalEdit.text10')}}￥{{goal.sum_income || 0}}</div>
                </template>
            </div>
            <btn class="look3" @click.native="save">{{$t('c.GoalEdit.text11')}}</btn>
        </div>
        <div class="over"></div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import { POST_EDIT_GOAL, POST_DEL_GOAL, POST_CREATOR_HIDE_GOAL, POST_CREATOR_SHOW_GOAL } from '@/api/config'
export default {
    name: 'goal-edit',
    props: {
        goal:{
            type:Object,
            default(){
                return {}
            },
        },
        type:{
            default(){
                return 1
            },
        },
        index:{
            default(){
                return 0
            },
        },
        begin_time:{
            default(){
                return 0
            },
        },
        end_time:{
            default(){
                return 0
            },
        }
    },
    // components:{
    //     DatePicker
    // },
    data() {
        return {
            monthly_fans: this.goal.monthly_fans * 1 >= 0 ? this.goal.monthly_fans  : '',
            monthly_income:this.goal.monthly_income * 1 >= 0 ? this.goal.monthly_income : '',
            goal_id: this.goal.goal_id || '',
            desc: this.goal.desc || '',
            status: this.goal.status || 1,
            g_type: this.goal.type || 1,
            // begin_time:this.goal.begin_time ? new Date(this.goal.begin_time * 1000) : null,
            // end_time:this.goal.end_time ? new Date(this.goal.end_time * 1000) : null,
        }
    },
    watch:{
        begin_time(val,oldValue){
            if(oldValue != 0 && this.goal.type == this.goal_type.sum_income){
                this.save(false);
            }
        },
        end_time(val,oldValue){
            if(oldValue != 0 && this.goal.type == this.goal_type.sum_income){
                this.save(false);
            }
        }
    },
    computed:{
        ...mapState('app',[
            'is_client',
            'upload',
            'goal_type',
            'goal_status',
            'session_user',
        ]),
        is_hide(){
            return this.status == this.goal_status.hide
        },
        post_data(){
            return {
                goal_id:this.goal_id,
                monthly_income:this.monthly_income,
                monthly_fans:this.monthly_fans,
                desc:this.desc,
                status:this.status,
                type:this.g_type,
                // begin_time:this.begin_time,//透传统一所有累计 goal 的时间
                // end_time:this.end_time, //透传统一所有累计 goal 的时间
                begin_time:this.begin_time ? parseInt(this.begin_time.getTime() / 1000) : '', //透传统一所有累计 goal 的时间
                end_time:this.end_time? parseInt(this.end_time.getTime() / 1000) : '', //透传统一所有累计 goal 的时间
            }
        },
        percent_sponsor(){
            let result = this.session_user ? parseInt(this.session_user.creator.monthly_fans / this.monthly_fans * 100) : 0;
            return isNaN(result) ? '0' : result
        },
        percent_money(){
            let result = this.session_user ? parseInt(this.session_user.creator.monthly_income / this.monthly_income * 100): 0;
            return isNaN(result) ? '0' : result
        },
    },
    mounted() {
    },
    methods: {
        async toggle(type){
            let API = type == 'show' ? POST_CREATOR_SHOW_GOAL : POST_CREATOR_HIDE_GOAL;
            if(this.$http.is_run(API)){
                return false
            }
            let data = await this.$http.$axios(API , {goal_id: this.goal_id})

            if(data.ec != 200){
                this.$notify({
                    title: data.em,
                    group: 'error',
                })
                return false
            }
            this.status = type == 'show' ? this.goal_status.normal : this.goal_status.hide;
        },
        async remove(){
            let re = await this.$mixin_confirm({title:'确认删除吗？'})
            if (!re) {
                return false;
            }

            if(!this.goal_id){ //如果是个不存在的goal，就是前端伪造的占位goal
                this.$emit('remove')
                return false
            }

            if(this.$http.is_run(POST_DEL_GOAL)){
                return false
            }
            let data = await this.$http.$axios(POST_DEL_GOAL , {goal_id: this.goal_id})

            this.$notify({
                title: data.em,
                group: data.ec == 200 ? 'success' : 'error',
            })

            if(data.ec == 200){
                this.$emit('remove')
            }
        },
        async save(is_show_tip = true){
            if(this.$http.is_run(POST_EDIT_GOAL)){
                return false
            }
            let data = await this.$http.$axios(POST_EDIT_GOAL , this.post_data)
            if(is_show_tip){
                this.$notify({
                    title: data.em,
                    group: data.ec == 200 ? 'success' : 'error',
                })
            }
            if(data.ec == 200){
                this.goal_id = data.data.goal.goal_id
                this.$emit('save', {goal:data.data.goal, index: this.index})
            }
        },
    }
};
</script>

<style lang="stylus" scoped>
.vm-goal-edit {
    background: $white;
    border-radius: px2rem(4);
    border: 1px solid $grey;
    position: relative;
    padding: px2rem(16);

    .afd-eye-off-box, .afd-eye, .afd-x {
        position: absolute;
        right: px2rem(16);
        top: px2rem(16);
        cursor: pointer;

        &:hover {
            color: $black-8;
        }
    }

    .afd-eye-off-box, .afd-eye {
        right: px2rem(48);
        z-index: 1;
    }

    .w50 {
        width: 50%;
    }

    .monthly-input {
        width: px2rem(240);
        padding: 0;
        border-bottom: 1px solid $grey;
    }

    .img-box {
        max-width: px2rem(320);

        .img-pre-box {
            margin-bottom: px2rem(16);

            img {
                width: auto;
                max-width: 100%;
            }
        }
    }

    &.is-hide {
        .over {
            background: $black-1;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            position: absolute;
        }
    }

    @media (max-width: $width-mobile) {
        .img-box {
            max-width: 100%;
        }
    }
}
</style>
